import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Subsections } from '../SessionSignOffV4.constant';
import { DetectedCaseNotesSection } from './DetectedCaseNotesSection';
import { SessionReportSection } from './SessionReportSection';

export const FeedbackForYouSection = ({
  selectedSubSection,
  setSelectedSubSection,
  appointment,
  openGiggle,
  handleOpenReasoning,
  waitingForAI,
}) => {
  useEffect(() => {
    if (!selectedSubSection) setSelectedSubSection(Subsections.DETECTED_CASE_NOTES);
  }, [selectedSubSection, setSelectedSubSection]);

  const renderSubsectionContent = () => {
    switch (selectedSubSection) {
      case Subsections.DETECTED_CASE_NOTES:
        return (
          <DetectedCaseNotesSection
            appointment={appointment}
            openGiggle={openGiggle}
            handleOpenReasoning={handleOpenReasoning}
          />
        );
      // case Subsections.DETECTED_SOCIAL_DETERMINANTS:
      //   return <div>Detected Social Determinants Content</div>;
      // case Subsections.DETECTED_COGNITIVE_ISSUES:
      //   return <div>Detected Cognitive Issues Content</div>;
      case Subsections.REPORT_CARD:
        return (
          <SessionReportSection
            appointment={appointment}
            openGiggle={openGiggle}
            waitingForAI={waitingForAI}
          />
        );
      default:
        return <div>Select a subsection</div>;
    }
  };

  return <Box>{renderSubsectionContent()}</Box>;
};
